import React from 'react'

export default function Aboutus() {
    return (
        <>
            <div className='me2'>
                <div className='ssd'>
                    <h2>Who We Are.</h2>
                    <h1>Shri Shyam <span>Interior</span></h1>
                    <p>Shri Shyam Interior is an interior supplier that offers wholesale prices on interior goods.
                        <br />Shri shyam interior  was established in 2002.
                    </p>
                
                </div>
                <div className='pic'>
                    <img src="./images/logo.png" alt="" />
                </div>
            </div>

            <section>
                <div id='owner'>
                    <h5 style={{ "marginBottom": "1rem", "color": "orange", "marginTop": "3rem","textAlign":"center" }}>EXPLORE THE AWESOME</h5>
                    <h1 style={{ "marginBottom": "3rem", "fontSize": "3rem","textAlign":"center" }}>Company Owners</h1>
                    <div className='own'>

                        <div className='owner1'>
                            <img src="./images/papa.jpg" alt=""  />
                            <p> <b> Mr.Parmod Kumar Gupta </b></p>
                            <p>Owner</p>
                        </div>


                        <div className='owner1'>
                            <img src="./images/chacha.jpg" alt=""  />
                            <p> <b> Mr.Sandeep Gupta</b></p>
                            <p>owner</p>
                        </div>

                    </div>
                </div>
            </section>
        </>

    )
}
